export default function (http) {
    return {
        /**
         * 查询字典列表
         * @param data
         * @return {*}
         */
        queryDictList(data) {
            return http.json({
                url: '/erp/rep/house/query',
                data
            })
        },

        /**
         * 查询字典列表
         * @param data
         * @return {*}
         */
        getRepWarehouseStoreAndInfo(data) {
            return http.json({
                url: '/erp/rep/house/getRepWarehouseStoreAndInfo',
                data
            })
        },


        getRepWarehouseStoreNotOrderId(data){
            return http.json({
                url: '/erp/rep/house/getRepWarehouseStoreNotOrderId',
                data
            })
        },

        getRepWarehouseStoreAndInfoByAndSend(data) {
            return http.json({
                url: '/erp/rep/house/getRepWarehouseStoreAndInfoByAndSend',
                data
            })
        },

        /**
         * 查询字典列表
         * @param data
         * @return {*}
         */
        queryProInfoAndStock(data) {
            return http.json({
                url: '/erp/rep/house/queryProInfoAndStock',
                data
            })
        },


        queryRepairCategoryDictList(){
            return http.json({
                url: '/erp/rep/house/queryByCodeEqRepairCategory?code=repairCategory',
            })
        },
        /**
         * 获取字典详情
         * @param data
         * @return {*}
         */
        getDictInfo(data) {
            return http({
                url: `/erp/rep/house/get?id=${data.id}`,
                method: 'post'
            })
        },


        /**
         * 保存字典信息
         * @param data
         * @return {*}
         */
        saveDictInfo(data) {
            return http.json({
                url: '/erp/rep/house/save',
                data
            })
        },

        /**
         * 删除字典
         * @param data
         * @return {*}
         */
        removeDict(data) {
            return http.json({
                url: '/erp/rep/house/delete',
                data
            })
        },

        queryWareHousePermissions(data) {
            return http.json({
                url: '/sys/dict/list/permission',
                data
            })
        },


        /**
         * 查询角色列表
         * @param data
         * @return {*}
         */
        queryRepList (data) {
            return http.json({
                url: '/erp/rep/house/queryTree',
                data
            })
        },
    }
}



// WEBPACK FOOTER //
// ./src/configure/http/api/repHouse.js